import { api } from '@ezugi/utils/http/httpRequest';

import { OUTGOING_CALLS } from '../endpoints';

export const fetchOutgoingCalls = () => api.get(OUTGOING_CALLS);
